import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/data/company";

export default function CTABand({ title = "Tell us what you need — we'll source it.", subtitle }) {
  return (
    <section className="relative overflow-hidden bg-[#1E3A8A]" data-testid="cta-band">
      <div className="absolute inset-0 dot-grid opacity-30" aria-hidden />
      <div className="absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-[#E30613]/20 to-transparent" aria-hidden />
      <div className="container-nago relative py-14 lg:py-16 grid lg:grid-cols-3 gap-8 items-center">
        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-300">
            Request a Quote
          </div>
          <h3 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl text-white leading-tight">
            {title}
          </h3>
          {subtitle && <p className="mt-3 text-slate-300 max-w-2xl">{subtitle}</p>}
        </div>
        <div className="flex flex-col sm:flex-row lg:flex-col gap-3">
          <Link to="/contact" className="btn-primary" data-testid="cta-quote-btn">
            Request a Quote <ArrowRight className="w-4 h-4" />
          </Link>
          <a
            href={`tel:${COMPANY.phones[0].replace(/\s/g, "")}`}
            className="btn-outline !text-white !border-white hover:!bg-white hover:!text-[#1E3A8A]"
            data-testid="cta-call-btn"
          >
            <Phone className="w-4 h-4" /> {COMPANY.phones[0]}
          </a>
        </div>
      </div>
    </section>
  );
}
